import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

@Injectable()
export class VeiculoVendidoService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  private valorRecebido = new BehaviorSubject<any>(null);
  valorModal$ = this.valorRecebido.asObservable();

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/veiculo/vendido`;
  }

  // public getDados(
  //   data_inicial?: any,
  //   data_final?: any,
  //   dealers?: any,
  //   grupo_economico?: any,
  //   chassi?: any,
  //   situacao?: any,
  //   marca?: any,
  //   placa?: any,
  //   vendaDireta?: any, filter?: any): Observable<any> {
  //   return this.httpClient.get<any>(`${this.baseUrlService + '/veiculo/vendido/'}`, {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
  //     }),
  //     params: new HttpParams()
  //       .set('data_inicial', data_inicial.toString())
  //       .set('data_final', data_final.toString())
  //       .set('dealers', dealers.toString())
  //       .set('grupo_economico', grupo_economico.toString())
  //       .set('chassi', chassi.toString())
  //       .set('situacao', situacao.toString())
  //       .set('marca', marca.toString())
  //       .set('placa', placa.toString())
  //       .set('venda_direta', vendaDireta.toString())
  //   });
  // }
  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    grupo_economico?: any,
    chassi?: any,
    situacao?: any,
    marca?: any,
    placa?: any,
    vendaDireta?: any,
    documento_cliente?: any,
    modelo_veic?: any,
    filter?: any
  ): Observable<any> {
    let params = new HttpParams();

    if (data_inicial) params = params.set('data_inicial', data_inicial.toString());
    if (data_final) params = params.set('data_final', data_final.toString());
    if (dealers) params = params.set('dealers', dealers.toString());
    if (grupo_economico) params = params.set('grupo_economico', grupo_economico.toString());
    if (chassi) params = params.set('chassi', chassi.toString());
    if (situacao) params = params.set('situacao', situacao.toString());
    if (marca) params = params.set('marca', marca.toString());
    if (placa) params = params.set('placa', placa.toString());
    if (vendaDireta) params = params.set('venda_direta', vendaDireta.toString());
    if (documento_cliente) params = params.set('documento_cliente', documento_cliente.toString());
    if (modelo_veic) params = params.set('modelo_veic', modelo_veic.toString());

    return this.httpClient.get<any>(`${this.baseUrlService + '/veiculo/vendido/'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: params
    });
  }

  atualizarModal(event: any) {
    this.valorRecebido.next(event)
  }

  receberValorModal() {
    return this.valorRecebido.getValue()
  }
}
